module.exports = __webpack_public_path__ + "img/compact-Creative-demo.905fb62b.png";